__turbopack_context__.v({
  "arrow": "prematch-category-module-sass-module__bErnfW__arrow",
  "gameCount": "prematch-category-module-sass-module__bErnfW__gameCount",
  "opened": "prematch-category-module-sass-module__bErnfW__opened",
  "prematchRegionItem": "prematch-category-module-sass-module__bErnfW__prematchRegionItem",
  "region": "prematch-category-module-sass-module__bErnfW__region",
  "tournamentItemsList": "prematch-category-module-sass-module__bErnfW__tournamentItemsList",
});
